// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__mBDKa","icons":"Cart_icons__ZwKFP","cart1":"Cart_cart1__5Fqei","CartCard":"Cart_CartCard__09IIG","order":"Cart_order__rZyx7"};